// 3rd party fonts
import "@fontsource/poppins/300.css"; // font-light
import "@fontsource/poppins/400.css"; // font-normal
import "@fontsource/poppins/500.css"; // font-medium	
import "@fontsource/poppins/600.css"; // font-semibold
import "@fontsource/poppins/700.css"; // font-bold

// Our CSS
import "./css/global.scss";

// 3rd party JS
import "alpinejs";
import Prism from "prismjs";

// FontAwesome
// Selectively import icons that we're using in order to minimize the build size.
// See: https://fontawesome.com/how-to-use/javascript-api/setup/importing-icons
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
    faBrowser,
    faRocketLaunch,
    faTicket,
    faGamepad,
    faLifeRing,
    faClipboardList,
    faEnvelope,
    faBullhorn,
    faPlayCircle,
    faCommentSmile,
    faBuilding,
    faCoins,
    faGamepadAlt,
} from "@fortawesome/pro-duotone-svg-icons";
library.add(
    faBrowser,
    faRocketLaunch,
    faTicket,
    faGamepad,
    faLifeRing,
    faClipboardList,
    faEnvelope,
    faBullhorn,
    faPlayCircle,
    faCommentSmile,
    faBuilding,
    faCoins,
    faGamepadAlt,
);
// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch();

window.addEventListener('DOMContentLoaded', (event) => {
    // Announcement bar
    const root = document.getElementById("announcement-bar-root");
    if (root) {
        root.style.position = "sticky";
        root.style.top = "0px";
        root.style.zIndex = "95";
        syncHeaderOffset();

        const observer = new MutationObserver(() => {
            syncHeaderOffset();
        });
        observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "style", "hidden"] });

        if (window.ResizeObserver) {
            const resizeObserver = new ResizeObserver(() => {
                syncHeaderOffset();
            });
            resizeObserver.observe(root);
            if (root.firstElementChild) {
                resizeObserver.observe(root.firstElementChild);
            }
        }
    }
    document.addEventListener("visibilitychange", () => {
        syncHeaderOffset();
    });

    window.addEventListener("scroll", () => {
        syncHeaderOffset();
    }, { passive: true, once: true });

    // Light and responsive YouTube video embeds
    // Embed as: <div class="youtube-player" data-id="VIDEO_ID"></div>
    (function() {
        var div, n,
            v = document.getElementsByClassName("youtube-player");
        for (n = 0; n < v.length; n++) {
            div = document.createElement("div");
            div.setAttribute("data-id", v[n].dataset.id);
            div.innerHTML = youtubeThumb(v[n].dataset.id);
            div.onclick = youtubeIframe;
            v[n].appendChild(div);
        }
    }());

    // Prism syntax highlighting
    document.querySelectorAll('pre[class*=language-]').forEach(function(node) {
        node.classList.add('line-numbers');
    });
    Prism.highlightAll();

    // Open links to external domains found in a post in a new tab
    document.querySelectorAll('.post-full-content a').forEach((link) => {
        var a = new RegExp('/' + window.location.host + '/');
        if (!a.test(link.href)) {
            link.setAttribute("rel", "external");
            link.setAttribute("target", "_blank");
        }
    });

    // CTA hover
    const ctaButton = document.getElementById("hero-cta-btn");
    if (ctaButton) {
      ctaButton.addEventListener("mouseover", (event) => {
        event.target.classList.add('btn-cta');
        event.target.classList.remove('btn-default');
        document.getElementById("hero-cta").classList.add('bg-black');
        document.getElementById("hero-cta").classList.remove('bg-cta-gradient');
      })
      ctaButton.addEventListener("mouseout", (event) => {
        event.target.classList.add('btn-default');
        event.target.classList.remove('btn-cta');
        document.getElementById("hero-cta").classList.add('bg-cta-gradient');
        document.getElementById("hero-cta").classList.remove('bg-black');
      })
    }
});


function youtubeThumb(id) {
    var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
        play = '<div class="play"><i class="fa-duotone fa-play-circle fa-5x"></i></div>';
    return thumb.replace("ID", id) + play;
}

function youtubeIframe() {
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube-nocookie.com/embed/ID?enablejsapi=1&amp;rel=0&amp;autoplay=1&amp;fs=1&amp;origin=https://www.prefinery.com";
    iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("allowfullscreen", "1");
    this.parentNode.replaceChild(iframe, this);
}

function getVisibleAnnouncementHeight(root) {
    if (!root) return 0;
    const firstChild = root.firstElementChild;
    if (!firstChild) return 0;
    const style = window.getComputedStyle(firstChild);
    if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) return 0;
    const rect = firstChild.getBoundingClientRect();
    return rect.height > 0 ? Math.max(0, rect.bottom) : 0;
}

function syncHeaderOffset() {
    const root = document.getElementById("announcement-bar-root");
    const header = document.getElementById("header");
    if (!header) return;
    const offset = getVisibleAnnouncementHeight(root);
    header.style.top = `${offset}px`;
}